import LoopLoginLayout from '../../../../ui/Layout/Theme/LoopLoginLayout';
import LoopOnboardingLayout from '../../../../ui/Layout/Theme/LoopOnboardingLayout';
import type { CommonLayouts } from '../../ThemeTypes';

import showOrHideElements from './showOrHideElements';

const layout: CommonLayouts = {
  LoginLayout: LoopLoginLayout,
  OnboardingLayout: LoopOnboardingLayout,
  showOrHideElements,
};

export default layout;
